// Shared by Cloud Functions and the frontend (imported there as @shared).

/**
 * Turns a name into a URL-safe path: "Big Time League!" -> "big-time-league".
 * @param {string} name
 * @return {string}
 */
export function slugify(name) {
  return String(name).toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "")
      .slice(0, 50);
}
